import React from 'react';
import { Button, Paper, Stack, Typography } from '@mui/material';

export interface PlanningContextRequiredProps {
  title?: string;
  message?: string;
  onOpenPlanningCycle: () => void;
}

export default class PlanningContextRequired extends React.PureComponent<PlanningContextRequiredProps> {
  public render(): React.ReactNode {
    return (
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Stack spacing={2} alignItems="flex-start">
          <Stack spacing={0.5}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {this.props.title || 'Open a Planning Cycle'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {this.props.message ||
                'This workbench requires an active Planning Context. Select a Planning Cycle to continue.'}
            </Typography>
          </Stack>

          <Button variant="contained" onClick={this.props.onOpenPlanningCycle}>
            Open Planning Cycle
          </Button>
        </Stack>
      </Paper>
    );
  }
}
